import { IsNotEmpty, IsStrongPassword, MinLength } from 'class-validator';

import { Match } from '@app-velocity/validators';
import { t } from '@app-velocity/i18n';

export class UserChangePasswordDto {
  @IsNotEmpty({
    message: t('users:validation.password_cannot_be_empty'),
  })
  oldPassword = '';

  @IsNotEmpty({
    message: t('users:validation.password_cannot_be_empty'),
  })
  @MinLength(8, {
    message: t('users:validation.password_too_short', {
      minLength: 8,
    }),
  })
  @IsStrongPassword(
    {
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 0,
    },
    {
      message: t('users:validation.password_too_weak'),
    }
  )
  newPassword = '';

  @IsNotEmpty({
    message: t('users:validation.password_confirmation_cannot_be_empty'),
  })
  @Match('newPassword', { message: t('users:validation.passwords_do_not_match') })
  confirmPassword = '';
}
